import { auto } from '@popperjs/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);
import SliderPlugin from './slider-plugin';

class TestimonialsSliderPlugin extends SliderPlugin {

    static type: String = "testimonials";

    constructor(element: HTMLElement) {
        super(element);
    }

    init() {
        let buttons = this.getButtons();
        
        this.swiper = new Swiper(this.getClassPath(), {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            pagination: {
                el: buttons.pagiBtn,
                clickable: true,
            },
            navigation: {
                nextEl: buttons.nextBtn,
                prevEl: buttons.prevBtn
            },
        });
    }
}

export default TestimonialsSliderPlugin;